import { ToggleButton } from '../../..'

interface GameSettingsItemProps {
    label: string
    onClick: () => void
    isToggled: boolean
    disabled?: boolean
}

const GameSettingsItem = ({ label, onClick, isToggled, disabled }: GameSettingsItemProps) => {
    return (
        <div className="flex items-center justify-between py-[20px]" id="game-settings-item">
            <div className="text-[30px]">{label}</div>
            <ToggleButton onClick={onClick} isToggled={isToggled} disabled={disabled} />
        </div>
    )
}

export default GameSettingsItem
